import uid from "common/utils/uid";

export function deleteOrphanedEntitiesForDocEntityBase(doc: any, entityField: string, parentIds: string[]) {
  const table = doc[entityField] as { [id: string]: any };

  for (const entityId in table) {
    const entity = table[entityId];
    if (entity.parentId && !parentIds.includes(entity.parentId)) {
      delete doc[entityField][entityId];
    }
  }

  return doc;
}

export function migrateModelFromStaticRoomLayoutToDoc(doc: any, entityField: string, entityType: any) {
  doc[entityField] = {};

  if (!doc.roomLayouts) {
    return doc;
  }

  for (const roomLayoutId in doc.roomLayouts) {
    const roomLayout = doc.roomLayouts[roomLayoutId];
    const entitySet = roomLayout[entityField];
    if (!entitySet) {
      continue;
    }

    Object.keys(entitySet).forEach((entityId, i) => {
      const id = uid();
      doc[entityField][id] = {
        ...entitySet[entityId],
        id,
        parentId: roomLayoutId,
        sortIndex: i,
        entityType,
      };
    });

    delete roomLayout[entityField];
  }
}

export function migrateModelToExtendDocEntityBase(doc: any, entityField: any) {
  const entityIds = Object.keys(doc[entityField] ?? {});
  for (const entityId in doc[entityField]) {
    const entity = doc[entityField][entityId];
    entity.id = entityId;
    entity.sortIndex = entityIds.indexOf(entityId);
  }
}

export function forEachFormula(v: any, f: (formula: any) => void): any {
  if (typeof v === "object") {
    if (!v) {
      return;
    }

    if (v instanceof Array) {
      return v.forEach((x) => forEachFormula(x, f));
    }

    if (isFormula(v)) {
      f(v);
      return;
    }

    for (const key in v) {
      if (!v.hasOwnProperty(key)) {
        continue;
      }

      forEachFormula(v[key], f);
    }
  }
}

export function forEachRoom(json: any, f: (room: any) => void) {
  for (const blockId in json.blocks) {
    const block = json.blocks[blockId];
    for (const blockLayoutId in block.layouts) {
      const blockLayout = block.layouts[blockLayoutId];
      for (const locationId in blockLayout.rooms) {
        const room = blockLayout.rooms[locationId];
        f(room);
      }
    }
  }
}

export function forEachRoomNoBlockLayout(json: any, f: (room: any) => void) {
  for (const blockId in json.blocks) {
    const block = json.blocks[blockId];
    for (const locationId in block.rooms) {
      const room = block.rooms[locationId];
      f(room);
    }
  }
}

/**
 * @deprecated Do not use - the structure of Param has changed since inception.
 * Preserved for legacy reasons.
 */
export function addParamConfig(paramId: string, param: any) {
  if (!param.config) {
    (param as any).config = {
      type: "BUILDER",
      mgmtType: "OPTION",
      category: "Options",
      prettyName: paramId,
    };
  }

  if (param.config.mgmtType === undefined) {
    (param.config as any).mgmtType = "OPTION";
  }

  if (!param.config.valueConfig) {
    const valueConfig: { [key: string]: any } = {};

    for (const value of paramValues(param)) {
      if (value === undefined) {
        continue;
      }

      if (param.type === "STRING_ENUM") {
        valueConfig[value.toString()] = { prettyName: value as string, price: 0 };
      } else if ((param as any).type === "NUMBER_ENUM") {
        valueConfig[value.toString()] = { prettyName: value as string, price: 0 };
      } else {
        valueConfig[value.toString()] = { price: 0 };
      }
    }

    (param.config as any).valueConfig = valueConfig;
  }

  if (param.type === "BOOLEAN" && param.config.prettyName !== undefined) {
    if (param.config.prettyName === "BooleanParam") {
      (param.config as any).prettyName = paramId;
    }

    if (param.config.valueConfig["false"] && param.config.valueConfig["false"].prettyName === undefined) {
      param.config.valueConfig["false"] = {
        ...param.config.valueConfig["false"],
        prettyName: "No " + param.config.prettyName,
        price: 0,
      };
    }

    if (param.config.valueConfig["true"] && param.config.valueConfig["true"].prettyName === undefined) {
      param.config.valueConfig["true"] = {
        ...param.config.valueConfig["true"],
        prettyName: param.config.prettyName,
        price: 0,
      };
    }
  }
}

/**
 * @deprecated Do not use outside of this file - the structure of Param has changed since inception.
 * Preserved for legacy reasons.
 */
function paramValues(param: any): (string | boolean)[] {
  switch (param.type) {
    case "BOOLEAN":
      return [true, false];
    case "STRING_ENUM":
      return param.values;
  }

  return [];
}

function isFormula(v: any) {
  return !!v && typeof v === "object" && v.hasOwnProperty("type") && v.type === "FORMULA";
}
